import React from 'react';
import type { StockStatus } from '../../types/product';
const copy: Record<StockStatus, {
  short: string;
  long: string;
  dot: string;
  text: string;
}> = {
  'in-stock': {
    short: 'In stock · ships tomorrow',
    long: 'In stock — order before 22:00, delivered tomorrow',
    dot: 'bg-success',
    text: 'text-success'
  },
  low: {
    short: 'Only 4 left',
    long: 'Only 4 left — order before 22:00, delivered tomorrow',
    dot: 'bg-amber-500',
    text: 'text-amber-700'
  },
  preorder: {
    short: 'Pre-order · ships Nov 12',
    long: 'Pre-order — ships from November 12',
    dot: 'bg-sky-600',
    text: 'text-sky-700'
  }
};
export function StockLabel({
  status,
  long = false
}: {
  status: StockStatus;
  long?: boolean;
}) {
  const c = copy[status];
  return <p className={`flex items-center gap-1.5 text-xs font-medium ${c.text}`} data-id="element-447" data-mp="gnzlu7gf72bi">
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${c.dot}`} aria-hidden="true" data-id="element-448" data-mp="1e4g7o0dyaj5h" />
      {long ? c.long : c.short}
    </p>;
}